var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-scroll-ranking-board',{staticStyle:{"width":"100%","height":"300px"},attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }